module.exports = [
	{
		"id": 4,
		"name": "Afghanistan"
	},
	{
		"id": 8,
		"name": "Albania"
	},
	{
		"id": 12,
		"name": "Algeria"
	},
	{
		"id": 24,
		"name": "Angola"
	},
	{
		"id": 10,
		"name": "Antarctica"
	},
	{
		"id": 32,
		"name": "Argentina"
	},
	{
		"id": 51,
		"name": "Armenia"
	},
	{
		"id": 36,
		"name": "Australia"
	},
	{
		"id": 40,
		"name": "Austria"
	},
	{
		"id": 31,
		"name": "Azerbaijan"
	},
	{
		"id": 44,
		"name": "Bahamas"
	},
	{
		"id": 50,
		"name": "Bangladesh"
	},
	{
		"id": 112,
		"name": "Belarus"
	},
	{
		"id": 56,
		"name": "Belgium"
	},
	{
		"id": 84,
		"name": "Belize"
	},
	{
		"id": 204,
		"name": "Benin"
	},
	{
		"id": 64,
		"name": "Bhutan"
	},
	{
		"id": 68,
		"name": "Bolivia, Plurinational State of"
	},
	{
		"id": 70,
		"name": "Bosnia and Herzegovina"
	},
	{
		"id": 72,
		"name": "Botswana"
	},
	{
		"id": 76,
		"name": "Brazil"
	},
	{
		"id": 96,
		"name": "Brunei Darussalam"
	},
	{
		"id": 100,
		"name": "Bulgaria"
	},
	{
		"id": 854,
		"name": "Burkina Faso"
	},
	{
		"id": 108,
		"name": "Burundi"
	},
	{
		"id": 116,
		"name": "Cambodia"
	},
	{
		"id": 120,
		"name": "Cameroon"
	},
	{
		"id": 124,
		"name": "Canada"
	},
	{
		"id": 140,
		"name": "Central African Republic"
	},
	{
		"id": 148,
		"name": "Chad"
	},
	{
		"id": 152,
		"name": "Chile"
	},
	{
		"id": 156,
		"name": "China"
	},
	{
		"id": 170,
		"name": "Colombia"
	},
	{
		"id": 178,
		"name": "Congo"
	},
	{
		"id": 180,
		"name": "Congo, the Democratic Republic of the"
	},
	{
		"id": 188,
		"name": "Costa Rica"
	},
	{
		"id": 384,
		"name": "Cote dIvoire"
	},
	{
		"id": 191,
		"name": "Croatia"
	},
	{
		"id": 192,
		"name": "Cuba"
	},
	{
		"id": 196,
		"name": "Cyprus"
	},
	{
		"id": 203,
		"name": "Czech Republic"
	},
	{
		"id": 208,
		"name": "Denmark"
	},
	{
		"id": 262,
		"name": "Djibouti"
	},
	{
		"id": 214,
		"name": "Dominican Republic"
	},
	{
		"id": 218,
		"name": "Ecuador"
	},
	{
		"id": 818,
		"name": "Egypt"
	},
	{
		"id": 222,
		"name": "El Salvador"
	},
	{
		"id": 226,
		"name": "Equatorial Guinea"
	},
	{
		"id": 232,
		"name": "Eritrea"
	},
	{
		"id": 233,
		"name": "Estonia"
	},
	{
		"id": 231,
		"name": "Ethiopia"
	},
	{
		"id": 238,
		"name": "Falkland Islands (Malvinas)"
	},
	{
		"id": 242,
		"name": "Fiji"
	},
	{
		"id": 246,
		"name": "Finland"
	},
	{
		"id": 250,
		"name": "France"
	},
	{
		"id": 260,
		"name": "French Southern Territories"
	},
	{
		"id": 266,
		"name": "Gabon"
	},
	{
		"id": 270,
		"name": "Gambia"
	},
	{
		"id": 268,
		"name": "Georgia"
	},
	{
		"id": 276,
		"name": "Germany"
	},
	{
		"id": 288,
		"name": "Ghana"
	},
	{
		"id": 300,
		"name": "Greece"
	},
	{
		"id": 304,
		"name": "Greenland"
	},
	{
		"id": 320,
		"name": "Guatemala"
	},
	{
		"id": 324,
		"name": "Guinea"
	},
	{
		"id": 624,
		"name": "Guinea-Bissau"
	},
	{
		"id": 328,
		"name": "Guyana"
	},
	{
		"id": 332,
		"name": "Haiti"
	},
	{
		"id": 340,
		"name": "Honduras"
	},
	{
		"id": 348,
		"name": "Hungary"
	},
	{
		"id": 352,
		"name": "Iceland"
	},
	{
		"id": 356,
		"name": "India"
	},
	{
		"id": 360,
		"name": "Indonesia"
	},
	{
		"id": 364,
		"name": "Iran, Islamic Republic of"
	},
	{
		"id": 368,
		"name": "Iraq"
	},
	{
		"id": 372,
		"name": "Ireland"
	},
	{
		"id": 376,
		"name": "Israel"
	},
	{
		"id": 380,
		"name": "Italy"
	},
	{
		"id": 388,
		"name": "Jamaica"
	},
	{
		"id": 392,
		"name": "Japan"
	},
	{
		"id": 400,
		"name": "Jordan"
	},
	{
		"id": 398,
		"name": "Kazakhstan"
	},
	{
		"id": 404,
		"name": "Kenya"
	},
	{
		"id": 408,
		"name": "Korea, Democratic Peoples Republic of"
	},
	{
		"id": 410,
		"name": "Korea, Republic of"
	},
	{
		"id": 414,
		"name": "Kuwait"
	},
	{
		"id": 417,
		"name": "Kyrgyzstan"
	},
	{
		"id": 418,
		"name": "Lao Peoples Democratic Republic"
	},
	{
		"id": 428,
		"name": "Latvia"
	},
	{
		"id": 422,
		"name": "Lebanon"
	},
	{
		"id": 426,
		"name": "Lesotho"
	},
	{
		"id": 430,
		"name": "Liberia"
	},
	{
		"id": 434,
		"name": "Libya"
	},
	{
		"id": 440,
		"name": "Lithuania"
	},
	{
		"id": 442,
		"name": "Luxembourg"
	},
	{
		"id": 807,
		"name": "Macedonia, the former Yugoslav Republic of"
	},
	{
		"id": 450,
		"name": "Madagascar"
	},
	{
		"id": 454,
		"name": "Malawi"
	},
	{
		"id": 458,
		"name": "Malaysia"
	},
	{
		"id": 466,
		"name": "Mali"
	},
	{
		"id": 478,
		"name": "Mauritania"
	},
	{
		"id": 484,
		"name": "Mexico"
	},
	{
		"id": 498,
		"name": "Moldova, Republic of"
	},
	{
		"id": 496,
		"name": "Mongolia"
	},
	{
		"id": 499,
		"name": "Montenegro"
	},
	{
		"id": 504,
		"name": "Morocco"
	},
	{
		"id": 508,
		"name": "Mozambique"
	},
	{
		"id": 104,
		"name": "Myanmar"
	},
	{
		"id": 516,
		"name": "Namibia"
	},
	{
		"id": 524,
		"name": "Nepal"
	},
	{
		"id": 528,
		"name": "Netherlands"
	},
	{
		"id": 540,
		"name": "New Caledonia"
	},
	{
		"id": 554,
		"name": "New Zealand"
	},
	{
		"id": 558,
		"name": "Nicaragua"
	},
	{
		"id": 562,
		"name": "Niger"
	},
	{
		"id": 566,
		"name": "Nigeria"
	},
	{
		"id": 578,
		"name": "Norway"
	},
	{
		"id": 512,
		"name": "Oman"
	},
	{
		"id": 586,
		"name": "Pakistan"
	},
	{
		"id": 275,
		"name": "Palestinian Territory, Occupied"
	},
	{
		"id": 591,
		"name": "Panama"
	},
	{
		"id": 598,
		"name": "Papua New Guinea"
	},
	{
		"id": 600,
		"name": "Paraguay"
	},
	{
		"id": 604,
		"name": "Peru"
	},
	{
		"id": 608,
		"name": "Philippines"
	},
	{
		"id": 616,
		"name": "Poland"
	},
	{
		"id": 620,
		"name": "Portugal"
	},
	{
		"id": 630,
		"name": "Puerto Rico"
	},
	{
		"id": 634,
		"name": "Qatar"
	},
	{
		"id": 642,
		"name": "Romania"
	},
	{
		"id": 643,
		"name": "Russia"
	},
	{
		"id": 646,
		"name": "Rwanda"
	},
	{
		"id": 682,
		"name": "Saudi Arabia"
	},
	{
		"id": 686,
		"name": "Senegal"
	},
	{
		"id": 688,
		"name": "Serbia"
	},
	{
		"id": 694,
		"name": "Sierra Leone"
	},
	{
		"id": 703,
		"name": "Slovakia"
	},
	{
		"id": 705,
		"name": "Slovenia"
	},
	{
		"id": 90,
		"name": "Solomon Islands"
	},
	{
		"id": 706,
		"name": "Somalia"
	},
	{
		"id": 710,
		"name": "South Africa"
	},
	{
		"id": 728,
		"name": "South Sudan"
	},
	{
		"id": 724,
		"name": "Spain"
	},
	{
		"id": 144,
		"name": "Sri Lanka"
	},
	{
		"id": 729,
		"name": "Sudan"
	},
	{
		"id": 740,
		"name": "Suriname"
	},
	{
		"id": 748,
		"name": "Swaziland"
	},
	{
		"id": 752,
		"name": "Sweden"
	},
	{
		"id": 756,
		"name": "Switzerland"
	},
	{
		"id": 760,
		"name": "Syrian Arab Republic"
	},
	{
		"id": 158,
		"name": "Taiwan, Province of China"
	},
	{
		"id": 762,
		"name": "Tajikistan"
	},
	{
		"id": 834,
		"name": "Tanzania, United Republic of"
	},
	{
		"id": 764,
		"name": "Thailand"
	},
	{
		"id": 626,
		"name": "Timor-Leste"
	},
	{
		"id": 768,
		"name": "Togo"
	},
	{
		"id": 780,
		"name": "Trinidad and Tobago"
	},
	{
		"id": 788,
		"name": "Tunisia"
	},
	{
		"id": 792,
		"name": "Turkey"
	},
	{
		"id": 795,
		"name": "Turkmenistan"
	},
	{
		"id": 800,
		"name": "Uganda"
	},
	{
		"id": 804,
		"name": "Ukraine"
	},
	{
		"id": 784,
		"name": "United Arab Emirates"
	},
	{
		"id": 826,
		"name": "United Kingdom"
	},
	{
		"id": 840,
		"name": "United States"
	},
	{
		"id": 858,
		"name": "Uruguay"
	},
	{
		"id": 860,
		"name": "Uzbekistan"
	},
	{
		"id": 548,
		"name": "Vanuatu"
	},
	{
		"id": 862,
		"name": "Venezuela, Bolivarian Republic of"
	},
	{
		"id": 704,
		"name": "Viet Nam"
	},
	{
		"id": 732,
		"name": "Western Sahara"
	},
	{
		"id": 887,
		"name": "Yemen"
	},
	{
		"id": 894,
		"name": "Zambia"
	},
	{
		"id": 716,
		"name": "Zimbabwe"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing/directives/dashboard/world-110m-country-names.json
 ** module id = 932
 ** module chunks = 0
 **/